import axios from "axios";
import { getCsrfToken } from "@/util/csrf";

const csrfToken = getCsrfToken();
if (csrfToken != null) {
  axios.defaults.headers.common["X-CSRF-Token"] = csrfToken;
}

export const api = axios.create({
  baseURL: "/",
  timeout: 0, // timeout設定なし（サーバーサイドに任せる）
});

declare const window: Window & {
  config?: {
    admin_path?: string;
  };
};

export const ADMIN_PATH =
  (typeof window !== "undefined" && window.config && window.config.admin_path) || "";
